import service from "./service";
import endpoint from "./constantUrl";

// Help
export const addHelp = (data) => {
  return service.post(`${endpoint.MARLIN_URL}/v1/support/help`, data);
};
